// Path: ./src/utils/dtoUtil/makeStoreDisplayName.ts
import { GfStore } from "@swagger/typescript-fetch-goflyer";

export function makeStoreDisplayName(store: GfStore) {
  return `${store.merchant.name} ${store.signature ? store.signature : ""}`;
}
